var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 21.868a.7.7 0 100 1.4v-1.4zm10 1.4a.7.7 0 100-1.4v1.4zm-4.3-5.101a.7.7 0 10-1.4 0h1.4zm-14.7-3.3h28v-1.4h-28v1.4zm1-13h26v-1.4h-26v1.4zm26.3.3v15h1.4v-15h-1.4zm-.3 15.3h-26v1.4h26v-1.4zm-26.3-.3v-15H.8v15h1.4zm.3.3a.3.3 0 01-.3-.3H.8a1.7 1.7 0 001.7 1.7v-1.4zm26.3-.3a.3.3 0 01-.3.3v1.4a1.7 1.7 0 001.7-1.7h-1.4zm-.3-15.3a.3.3 0 01.3.3h1.4a1.7 1.7 0 00-1.7-1.7v1.4zm-26-1.4a1.7 1.7 0 00-1.7 1.7h1.4a.3.3 0 01.3-.3v-1.4zm12.3 17.7v4.4h1.4v-4.4h-1.4zm-4.3 5.1h5v-1.4h-5v1.4zm5 0h5v-1.4h-5v1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.5 8.167h10v16.667h-10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.917 21.917a.417.417 0 11-.834 0 .417.417 0 01.834 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3A4850",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M27.833 10.667h3.334M25.75 24.834h7.5c.69 0 1.25-.56 1.25-1.25V9.417c0-.69-.56-1.25-1.25-1.25h-7.5c-.69 0-1.25.56-1.25 1.25v14.167c0 .69.56 1.25 1.25 1.25zm4.167-2.917a.417.417 0 11-.834 0 .417.417 0 01.834 0z"
  })));
}
export default SvgMobileDesktop;